import { ListingPlugin, SmartADVItem } from '@/shared/models';
import { all } from '@/shared/models/ListingPlugins/matchers';
import { afterGalleryAndCompleteRowPositionRepeatedly } from '@/shared/models/ListingPlugins/position';

export const generateADVItems = (
  listLength: number,
  advFrequency: number,
  columnCount = 1,
  galleryCount = 0
): Array<ListingPlugin> => {
  const advItems: ListingPlugin[] = [];

  for (
    let i = advFrequency, advIndex = 1;
    i < listLength;
    i += advFrequency * columnCount, advIndex++
  ) {
    const advItem: ListingPlugin = {
      model: new SmartADVItem(
        {
          source: 'lira',
          id: `listing-in-content-${advIndex}`,
          style: { minHeight: '200px' },
        },
        {
          source: 'lira',
          id: `listing-in-content-${advIndex}`,
          style: { minHeight: '150px' },
        }
      ),
      position: afterGalleryAndCompleteRowPositionRepeatedly({
        columnCount,
        galleryCount,
        iteration: advIndex,
        frequency: advFrequency,
      }),
      categories: all(),
    };
    advItems.push(advItem);
  }

  return advItems;
};
